import { useEffect } from 'react';

import { Layout } from '../components/Layout';

export function DemoPage() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://microfb.com/widget/widget.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <Layout mode="public">
      <section className="py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-slate-900 mb-4">Widget Demo</h1>
            <p className="text-xl text-slate-600 max-w-3xl mx-auto">
              Experience both widget styles in action. Try them out and see which one works best for your website.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
            <div className="bg-white rounded-lg shadow-lg p-8">
              <div className="text-center mb-6">
                <h2 className="text-2xl font-bold text-slate-900 mb-2">Inline Widget</h2>
                <p className="text-slate-600">Embeds directly into your content. Perfect for articles and pages.</p>
              </div>
              <div className="border-2 border-dashed border-gray-300 rounded-lg p-6">
                <h3 className="text-lg font-medium text-slate-900 mb-4">Sample Article Content</h3>
                <p className="text-slate-600 mb-4">This is a sample article or blog post. The inline widget appears directly within the content flow, making it natural for users to provide feedback.</p>
                <p className="text-slate-600 mb-6">You can place the widget anywhere in your content where feedback would be most valuable.</p>
                <div className="flex justify-center">
                  <div data-mfb-site-id="demo-site-inline" data-mfb-skin="inline" data-mfb-theme="light"></div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-8">
              <div className="text-center mb-6">
                <h2 className="text-2xl font-bold text-slate-900 mb-2">Drawer Widget</h2>
                <p className="text-slate-600">Fixed feedback button that opens a modal. Non-intrusive and always accessible.</p>
              </div>
              <div className="border-2 border-dashed border-gray-300 rounded-lg p-6">
                <h3 className="text-lg font-medium text-slate-900 mb-4">Look for the &ldquo;Feedback&rdquo; Button</h3>
                <p className="text-slate-600 mb-4">The drawer widget creates a fixed button on the right edge of your screen. It&apos;s always visible and doesn&apos;t interfere with your content layout.</p>
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
                  <div className="flex items-center">
                    <div className="text-blue-500 text-xl mr-3">👉</div>
                    <div>
                      <p className="text-blue-800 font-medium">Try it now!</p>
                      <p className="text-blue-700 text-sm">Look for the black &ldquo;Feedback&rdquo; button on the right edge of your screen.</p>
                    </div>
                  </div>
                </div>
                <div data-mfb-site-id="demo-site-drawer" data-mfb-skin="drawer" data-mfb-theme="light"></div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-lg p-8 mb-12">
            <h2 className="text-2xl font-bold text-slate-900 text-center mb-8">How to Use</h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div>
                <h3 className="text-lg font-semibold text-slate-900 mb-4">Inline Widget</h3>
                <div className="bg-gray-100 rounded-lg p-4">
                  <code className="text-sm text-slate-800 whitespace-pre-wrap">{`<script src="https://microfb.com/widget/widget.js"></script>
<div data-mfb-site-id="your-site-id" 
     data-mfb-skin="inline" 
     data-mfb-theme="light"></div>`}</code>
                </div>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-slate-900 mb-4">Drawer Widget</h3>
                <div className="bg-gray-100 rounded-lg p-4">
                  <code className="text-sm text-slate-800 whitespace-pre-wrap">{`<script src="https://microfb.com/widget/widget.js"></script>
<div data-mfb-site-id="your-site-id" 
     data-mfb-skin="drawer" 
     data-mfb-theme="light"></div>`}</code>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}


